import { render } from "./Services-business-owner.vue?vue&type=template&id=27551ac4&scoped=true"
import script from "./Services-business-owner.vue?vue&type=script&lang=js"
export * from "./Services-business-owner.vue?vue&type=script&lang=js"

import "./Services-business-owner.vue?vue&type=style&index=0&id=27551ac4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27551ac4"]])

export default __exports__